import { once } from './once'

/**
 * The Fonts loader logic.
 * 1. Load fonts from the list
 * 2. If fonts are not loded until `timeOut` ends,
 *    then call `callback` with `true` fallback flag and ignore enything else
 * 3. If fonts are loaded during `timeOut`, then add them `document.fonts`
 * 4. call the `callback`
 */

const timeOut = 1500

export const fontsLoader = async (cb: () => void) => {
  const callback = once(cb)

  if (!FontFace) {
    callback()
    return
  }

  setTimeout(() => {
    callback(true)
  }, timeOut)

  const fonts = await Promise.all(
    [
      {
        name: 'HelveticaNeueW01-45Ligh',
        handle: '530dee22-e3c1-4e9f-bf62-c31d510d9656',
      },
      {
        name: 'HelveticaNeueW01-55Roma',
        handle: 'bcf54343-d033-41ee-bbd7-2b77df3fe7ba',
      },
      {
        name: 'HelveticaNeueW01-65Medi',
        handle: '60be5c39-863e-40cb-9434-6ebafb62ab2b',
      },
    ].map(({ name, handle }) => {
      const font = new FontFace(
        name,
        `url(https://static.parastorage.com/services/third-party/fonts/Helvetica/Fonts/${handle}.woff)`,
      )
      font.display = 'swap'

      return font.load().catch(() => null)
    }),
  )

  if (callback.executed) {
    return
  }

  await Promise.all(
    fonts.filter(Boolean).map((font) => document.fonts.add(font as FontFace)),
  )

  callback()
}
